module.exports = __webpack_public_path__ + "media/images/workflow-settings-e785919e6df1974d54e6e355fcdcb331.svg";